module.exports = __webpack_public_path__ + "img/heading-solid.82abf112.svg";